import React, { useState, useRef } from "react";
import { makeStyles } from "@material-ui/styles";
import {
  Button,
  Grid,
  TextField,
  Typography,
  Divider,
} from "@material-ui/core";
import AccountCircleOutlinedIcon from "@material-ui/icons/AccountCircleOutlined";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import PhoneIcon from "@material-ui/icons/Phone";
import DescriptionOutlinedIcon from "@material-ui/icons/DescriptionOutlined";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import ReCAPTCHA from "react-google-recaptcha";
// import "assets/css/phone-input.css";
import PhoneInput from "components/PhoneInput";
import Alert from "@material-ui/lab/Alert";
import Api from "api";
import Snackbar from "components/Snackbar";

const useStyles = makeStyles((theme) => ({
  inline: {
    lineHeight: "normal",
    fontWeight: "bold",
  },
  subHead: {
    fontSize: "80%",
  },
  fieldIcon: {
    marginBottom: "-18px",
  },
  submit: {
    marginTop: "1rem",
    textTransform: "none",
  },
  heading: {
    marginBottom: "1rem",
  },
  checkbox: {
    alignItems: "start",
    "& .MuiFormControlLabel-label": {
      color: "grey",
      fontSize: "small",
    },
  },
  captcha: {
    margin: "1rem 0",
  },
  alert: {
    marginBottom: "5px",
  },
  phone: {
    border: "none",
    borderBottom: "1px solid grey",
    padding: "7px 0",
    marginTop: "16px",
  },
}));

function index({
  recap_key,
  website_language,
  website_country,
  referralSiteDetails,
  setShowReferralForm,
  referral_comment_box_setting,
  
}) {
  const classes = useStyles();
  const initialValues = {
    name: "",
    email: "",
    phone: "",
    message: "",
  };
  const captchaRef = useRef();
  const [showAlert, setShowAlert] = useState(false);
  const [showError, setShowError] = useState({
    open: false,
    severity: "error",
    message: "something went wrong",
  });
  const [values, setValues] = useState(initialValues);
  const [checked, setChecked] = useState(false);
  const [captcha, setCaptcha] = useState(null);
  const [volunteer_reg_link, setVolunteerRegLink] = useState('#');

  const {
    "siteLocator:connect": {
      site: { trial_id, site_id },
    },
  } = referralSiteDetails;
  const widget_id = window.__WIDGET_ID__;
 const volunteer_signup_link_label = window.__VOLUNTEER_SIGNUP_LINK_LABEL__;
 const volunteer_signup_text=window.__VOLUNTEER_SIGNUP_TEXT__;
 
const widget_source = window.parent.__WEBSITE_CONTEXT__.widget_source;
  const referralSent = () => {
    setValues(initialValues);
    setChecked(false);
    captchaRef.current.reset();

    setShowAlert(true);
  };
  const referralNotSent = (reason) => {
    captchaRef.current.reset();

    setShowError({
      open: true,
      severity: "error",
      message: `Error while contacting trial site : ${reason}`,
    });
  };

  const sendReferralMessage = () => {
    const url = `/message/direct/`;

    const headers = { "X-Requested-With": "XMLHttpRequest" };

    const data = new FormData();
    data.append("phonenumber", values.phone);
    data.append("firstname", values.name);
    data.append("lastname", "");
    data.append("email", values.email);
    data.append("comment", values.message);
    data.append("trial", trial_id);
    data.append("site_id", site_id);
    data.append("widget_id", widget_id);
    data.append("volunteer_link", true);
    data.append("g-recaptcha-response", captcha);
    data.append("language_code", website_language);
    data.append("country_code", website_country);

    Api.post(url, data, { headers })
      .then(({ status, data }) => {
        if (status === 200) {
          const {
            existing_volunteer: existingVolunteer,
            reason,
            status: success,
            volunteer_link: volunteerLink,
          } = data;
          if(!existingVolunteer){
            setVolunteerRegLink(volunteerLink);
          }
          
          success ? referralSent() : referralNotSent(reason);
          return success
            ? Promise.resolve({ existingVolunteer, volunteerLink })
            : Promise.reject(new Error(reason));
        }
      })
      .catch(() => {
        captchaRef.current.reset();

        setShowError({
          open: true,
          severity: "error",
          message: `Error while contacting trial site`,
        });
        return Promise.reject(new Error("Error while contacting trial site"));
      });
  };

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setValues((vals) => ({ ...vals, [name]: value }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    sendReferralMessage();
  };

  const {
    "siteLocator:connect": { site: data },
  } = referralSiteDetails;

  return (
    <div id="referral-form">
      <Grid container>
        <Grid item md={3}></Grid>
        <Grid item md={6}>
          <Grid container className={classes.heading}>
            <Grid
              item
              xs={6}
              style={{
                display: "flex",
                alignItems: "flex-end",
                justifyContent: "space-between",
              }}
            >
              <div style={{ display: "flex", alignItems: "flex-end" }}>
                <img
                  src={data?.investigator_avatar}
                  alt="avatar"
                  width={48}
                  height={48}
                  style={{
                    borderRadius: "50%",
                    backgroundColor: "rgb(173, 181, 189)",
                  }}
                />
                <div
                  style={{
                    maxWidth: "72%",
                    marginLeft: "1rem",
                    marginRight: "0.5rem",
                  }}
                >
                  <Typography
                    component="h6"
                    variant="body1"
                    className={classes.inline}
                    noWrap
                  >
                    {data?.investigator_name}
                  </Typography>
                  <Typography className={classes.subHead} noWrap>
                    Primary contact
                  </Typography>
                </div>
              </div>
              <Divider orientation="vertical" flexItem />
            </Grid>
            <Grid
              item
              xs={6}
              style={{ display: "flex", alignItems: "flex-end" }}
            >
              <img src={data?.site_icon} alt="icon" width={48} height={48} />
              <div style={{ maxWidth: "75%", marginLeft: "1rem" }}>
                <Typography
                  component="h6"
                  variant="body1"
                  className={classes.inline}
                  noWrap
                >
                  {data?.site_name}
                </Typography>
                <Typography className={classes.subHead} noWrap>
                  {data?.site_address}
                </Typography>
              </div>
            </Grid>
          </Grid>
          {showAlert && (
            <>
              <Alert className={classes.alert} severity="success">
                Your message has been sent to the study team at{" "}
                {data?.site_name}
              </Alert>
              <Alert className={classes.alert} severity="success">
                A copy of the message has been sent to your email
              </Alert>
             {volunteer_signup_text && volunteer_reg_link && (<Alert className={classes.alert} severity="info">
              <a href={volunteer_reg_link + `?tg=V&tgd=${widget_source || trial_id}&label=DRSSV`} target="_blank">{volunteer_signup_link_label}</a> {volunteer_signup_text}
              </Alert>)}
            </>
            
          )}
          <form onSubmit={handleSubmit}>
            <Grid container spacing={1} alignItems="center">
              <Grid item>
                <AccountCircleOutlinedIcon
                  color="primary"
                  fontSize="small"
                  className={classes.fieldIcon}
                />
              </Grid>
              <Grid item xs={11}>
                <TextField
                  name="name"
                  value={values.name}
                  label="Name"
                  onChange={handleChange}
                />
              </Grid>

              <Grid item>
                <MailOutlineIcon
                  color="primary"
                  fontSize="small"
                  className={classes.fieldIcon}
                />
              </Grid>
              <Grid item xs={11}>
                <TextField
                  name="email"
                  value={values.email}
                  label="Email"
                  onChange={handleChange}
                />
              </Grid>

              <Grid item>
                <PhoneIcon
                  color="primary"
                  fontSize="small"
                  className={classes.fieldIcon}
                />
              </Grid>
              <Grid item xs={11}>
                <PhoneInput
                  className={classes.phone}
                  name="phone"
                  value={values.phone}
                  placeholder="Enter phone number"
                  defaultCountry={
                    website_country?.toUpperCase() !== "GLOBAL"
                      ? website_country?.toUpperCase()
                      : "US" || "US"
                  }
                  onChange={(val) =>
                    handleChange({ target: { name: "phone", value: val } })
                  }
                />
              </Grid>
              
              {referral_comment_box_setting &&
              <>
                <Grid item>
                  <DescriptionOutlinedIcon
                    color="primary"
                    fontSize="small"
                    className={classes.fieldIcon}
                  />
                </Grid>
                <Grid item xs={11}>
                  <TextField
                    name="message"
                    label="Enter any additional details for study team"
                    value={values.message}
                    onChange={handleChange}
                    multiline
                    rows={3}
                  />
                </Grid>
              </>
              }
              <ReCAPTCHA
                className={classes.captcha}
                ref={captchaRef}
                sitekey={recap_key}
                onChange={setCaptcha}
              />

              <FormControlLabel
                className={classes.checkbox}
                control={
                  <Checkbox
                    name="checkedB"
                    color="primary"
                    checked={checked}
                    onChange={(e) => setChecked(e.target.checked)}
                  />
                }
                label="By sending a message, I agree that my data will be sent to a representative for the selected site and processed in accordance with this website's Privacy Policy (see link in footer)."
              />
            </Grid>

            <Grid container justify="space-between">
              <Button
                variant="outlined"
                className={classes.submit}
                onClick={() => {
                  setShowReferralForm(false);
                }}
              >
                Back
              </Button>
              <Button
                className={classes.submit}
                variant="contained"
                color="primary"
                type="submit"
                disabled={!checked || !captcha}
              >
                Send
              </Button>
            </Grid>
          </form>
        </Grid>
        <Grid item md={3}></Grid>
      </Grid>
      {showError.open && (
        <Snackbar
          open={showError.open}
          severity={showError.severity}
          message={showError.message}
        />
      )}
    </div>
  );
}

export default index;
